// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1RqQH","content":"styles_content__3QqKc","checkbox":"styles_checkbox__2Nrnw","checkboxLabel":"styles_checkboxLabel__Q6t0F"};